export default {
      id: "button-play-usage",
      viewBox: "0 0 33.33 33.33",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#button-play",
      toString: function () {
        return this.url;
      }
    }